import axiosInstance from "./axiosInstance";

const API_URL =
  process.env.REACT_APP_NAS_API_URL || "https://new.aquastrong-select.ru";

const TOKEN_KEY = "auth_token";
const USER_KEY = "auth_user";

/**
 * Авторизация пользователя
 * @param {string} email - Email пользователя
 * @param {string} password - Пароль пользователя
 * @returns {Promise<{token: string, user: object}>}
 */
export const login = async (email, password) => {
  const response = await axiosInstance.post(`${API_URL}/api/v1/auth/login`, {
    email,
    password,
  });

  // Сохраняем токен и данные пользователя в localStorage
  if (response.token) {
    localStorage.setItem(TOKEN_KEY, response.token);
  }

  if (response.user) {
    localStorage.setItem(USER_KEY, JSON.stringify(response.user));
  }

  return response;
};

/**
 * Получить токен из хранилища
 * @returns {string|null}
 */
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

/**
 * Получить данные пользователя из хранилища
 * @returns {object|null}
 */
export const getUser = () => {
  const user = localStorage.getItem(USER_KEY);
  return user ? JSON.parse(user) : null;
};

/**
 * Проверить авторизован ли пользователь
 * @returns {boolean}
 */
export const isAuthenticated = () => {
  return !!getToken();
};

/**
 * Выход из системы - удаление токена и данных пользователя
 */
export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};